import React from "react";
import { Container, Typography, Box, Paper, Link } from "@mui/material";
import Layout from "../components/Layout";

const TermsAndConditions: React.FC = () => {
  return (
    <Layout>
      <Container maxWidth={false} sx={{ py: 12,backgroundColor:"#172554" }}>
        <Typography
          variant="h5"
          align="center"
          color="white"
          gutterBottom
          sx={{marginBottom:"20px" }}
        >
          Terms and Conditions
        </Typography>

        <Paper
          sx={{
            p: 4,
            backgroundColor: "#f9f9f9",
            boxShadow: 3,
            borderRadius: 2,
            color: "text.secondary",
          }}
        >
          <Typography paragraph>
            Welcome to Matt Scholar Solutions! By using our services, you agree
            to the following terms and conditions:
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            1. Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing our website, you agree to be bound by these Terms and
            Conditions, as well as any additional terms, guidelines, or rules
            posted on our website. If you do not agree to these terms, you should
            not use our services.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            2. Our Services
          </Typography>
          <Typography paragraph>
            We provide a range of services, including software solutions,
            assignment writing assistance, tech support, academic solutions,
            hardware solutions, and digital marketing.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            3. Intellectual Property
          </Typography>
          <Typography paragraph>
            The content on our website, including but not limited to text,
            graphics, logos, images, and software, is the property of Matt
            Engineering Solutions and is protected by copyright and other laws.
            You may not use or reproduce any of our content without prior
            written consent.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            4. Privacy
          </Typography>
          <Typography paragraph>
            We respect your privacy and are committed to protecting your
            personal information. Please refer to our Privacy Policy for more
            information on how we collect, use, and protect your information.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            5. Third-Party Websites
          </Typography>
          <Typography paragraph>
            Our website may contain links to third-party websites that are not
            owned or operated by Matt Scholar Solutions. We are not responsible
            for the content, products, or services offered on these websites.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            6. Disclaimer of Warranties
          </Typography>
          <Typography paragraph>
            We make no warranties or representations about the accuracy,
            reliability, completeness, or timeliness of the content on our
            website or the services we provide. We disclaim all warranties,
            express or implied, including but not limited to implied warranties
            of merchantability and fitness for a particular purpose.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            7. Limitation of Liability
          </Typography>
          <Typography paragraph>
            Matt Scholar Solutions shall not be liable for any direct, indirect,
            incidental, special, or consequential damages resulting from your
            use of our website or the services we provide.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            8. Indemnification
          </Typography>
          <Typography paragraph>
            You agree to indemnify and hold Matt Scholar Solutions, its
            affiliates, officers, agents, and employees, harmless from any claim
            or demand, including reasonable attorneys’ fees, made by any third
            party due to or arising out of your use of our website or the
            services we provide.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            9. Governing Law
          </Typography>
          <Typography paragraph>
            These Terms and Conditions shall be governed by and construed in
            accordance with the laws of the Indian government, without giving
            effect to any principles of conflicts of law.
          </Typography>

          <Typography
            variant="h6"
            color="textPrimary"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            10. Changes to Terms and Conditions
          </Typography>
          <Typography paragraph>
            We reserve the right to modify or amend these Terms and Conditions
            at any time without prior notice. Your continued use of our website
            or services constitutes your acceptance of the updated Terms and
            Conditions.
          </Typography>

          <Typography variant="body1" sx={{ mt: 4 }}>
            If you have any questions about these Terms and Conditions, please
            contact us at -{" "}
            <Link
              href="mailto:matt@mattengg.com"
              color="primary"
              underline="hover"
            >
              info@mattengg.com
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Layout>
  );
};

export default TermsAndConditions;
